import Broadcast from "openbet-action-broadcast";
import { createLogger } from "redux-logger";

/**
 * Create a redux logger
 * @ignore
 */
const logger = createLogger({
  predicate: (getState, _) => Object.keys(getState()).length > 0
});

/**
 * Convenience method for creating stores with the OB action broadcast library. Enables components to send
 * messages across the eventBus by translating redux actions into browser events.
 *
 * @ignore
 * @param broadcastConfig
 * @param storeCreator
 * @param middleWare
 * @param initialState
 * @returns {*}
 */
const loadStore = (
  broadcastConfig,
  storeCreator,
  middleWare = [],
  initialState = {}
) => {
  const broadcast = new Broadcast(broadcastConfig);
  const broadcastMiddleware = broadcast
    .transmitter()
    .createTransmitterMiddleware();

  let store = storeCreator(initialState, [
    ...middleWare,
    broadcastMiddleware,
    logger
  ]);
  broadcast.initialiseReceiver(store);
  store.broadcast = broadcast;

  return store;
};

export default loadStore;



// WEBPACK FOOTER //
// ./src/stores/storeLoader.js